export function haveSameEntryKeys(
  entryKeys: string[],
  otherEntryKeys: string[],
): boolean {
  // Compared as sets: callers may pass lists with duplicate keys, and
  // duplicates don't change which related records a key set resolves to.
  const keySet = new Set(entryKeys);
  const otherKeySet = new Set(otherEntryKeys);

  return (
    keySet.size === otherKeySet.size &&
    [...keySet].every((entryKey) => otherKeySet.has(entryKey))
  );
}
